"use client"

import { PhoneIncoming } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PhoneIncomingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PhoneIncomingIcon = component(Icon)({ as: PhoneIncoming })
